import styled from 'styled-components';
import { colorError } from '@atlas-frontend/design-tokens';

export const TextDanger = styled.span`
  color: ${colorError};
`;
